import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsSnConstants {
    static STEP_TITLE = "Details";
    static APPLICATION_DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    static DESCRIPTION_FORM_LABEL = "Description";
    static APPLICATION_TYPE_FORM_LABEL = "Application type";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static APPLICATION_TYPE_LOOKOUT_NAME = "applicationType";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        referenceNumber: {
            required: `Reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
